import { Dispatch } from "react";
import AutodeskSymbolSvg from "components/icons/autodesk-symbol.svg";
import { AutodeskAccountModel } from "lib/types/autodesk/AutodeskAccountModel";
import { AutodeskImportAction } from "../autodeskImportReducer";
import AutodeskBrowserRow from "../controls/AutodeskBrowserRow";
import AutodeskFilteredList from "../controls/AutodeskFilteredList";

export default function AutodeskImportAccountStep(p: {
  accounts: AutodeskAccountModel[];
  dispatch: Dispatch<AutodeskImportAction>;
}) {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-thin">
        Select an <span className="font-normal">Autodesk account</span>
      </h1>
      <AutodeskFilteredList
        items={p.accounts}
        placeholder="Search accounts"
        emptyText="No accounts"
        getKey={(account) => account.id}
        getName={getAccountName}
        renderItem={(account) => (
          <AutodeskBrowserRow
            icon={<AutodeskSymbolSvg />}
            label={getAccountName(account)}
            onClick={() =>
              p.dispatch({ type: "CHOOSE_ACCOUNT", accountId: account.id })
            }
          />
        )}
      />
    </div>
  );
}

function getAccountName(account: AutodeskAccountModel) {
  return account.name || account.email || `Account ${account.id}`;
}
